// AppRoutes.jsx
import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useRechten } from "./context/RechtenContext";
import Layout from "./components/Layout";
import Home from "./home";
import MijnAanvragen from "./components/MijnAanvragen";
import Feedback from "./components/Feedback";

// Lazy-loaded componenten
const AdminBeheer = React.lazy(() => import("./components/AdminBeheer"));
const GebruikersBeheer = React.lazy(() => import("./components/GebruikersBeheer"));
const GebruikersActies = React.lazy(() => import("./components/GebruikersActies"));
const AanvragenBeoordelen = React.lazy(() => import("./components/AanvragenBeoordelen"));
const ToegangBuitenland = React.lazy(() => import("./components/ToegangBuitenland"));
const Klantbeheer = React.lazy(() => import("./components/Klantbeheer"));
const GebruikersOverzicht = React.lazy(() => import("./components/GebruikersOverzicht"));
const AgendaToegang = React.lazy(() => import("./components/AgendaToegang"));
const MailboxToegang = React.lazy(() => import("./components/MailboxToegang"));
const MfaReset = React.lazy(() => import("./components/MfaReset"));
const KlantOnboarding = React.lazy(() => import("./components/KlantOnboarding"));
const Compliance = React.lazy(() => import("./components/Compliance"));



export default function AppRoutes() {
  const { rechten, loading } = useRechten();
  const NGW_TENANT_ID = "601774b8-d827-4636-92d7-934d5fceff0f";

  if (loading) return <div className="p-6 text-gray-600">🔐 Rechten worden geladen...</div>;

  const heeftToegang = (vinkje) =>
    rechten?.[vinkje] || rechten?.FullAccess || rechten?.Administrator;

  const isNGW =
    typeof rechten?.TenantID === "string" &&
    rechten.TenantID.trim().toLowerCase() === NGW_TENANT_ID.toLowerCase();

  return (
    <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/feedback" element={<Layout><Feedback /></Layout>} />

      <Route
        path="/vakantie"
        element={
          heeftToegang("VakantieMFA") ? (
            <Suspense fallback={<div className="p-6">Laden...</div>}>
              <Layout><ToegangBuitenland /></Layout>
            </Suspense>
          ) : <Navigate to="/" />
        }
      />

      <Route
        path="/klantbeheer"
        element={
          rechten?.TenantID?.toLowerCase() === NGW_TENANT_ID.toLowerCase() ? (
            <Suspense fallback={<div className="p-6">Laden...</div>}>
              <Layout><Klantbeheer /></Layout>
            </Suspense>
          ) : <Navigate to="/" />
        }
      />

      <Route
        path="/gebruikers-overzicht"
        element={
          heeftToegang("GebruikersOverzicht") ? (
            <Suspense fallback={<div className="p-6">Laden...</div>}>
              <Layout><GebruikersOverzicht /></Layout>
            </Suspense>
          ) : <Navigate to="/" />
        }
      />

      <Route
        path="/gebruikersbeheer"
        element={
          heeftToegang("GebruikersBeheer") ? (
            <Suspense fallback={<div className="p-6">Laden...</div>}>
              <Layout><GebruikersBeheer /></Layout>
            </Suspense>
          ) : <Navigate to="/" />
        }
      />

      <Route
        path="/gebruikersacties"
        element={
          heeftToegang("GebruikersActies") ? (
            <Suspense fallback={<div className="p-6">Laden...</div>}>
              <Layout><GebruikersActies /></Layout>
            </Suspense>
          ) : <Navigate to="/" />
        }
      />

      <Route
        path="/aanvragenbeoordelen"
        element={
          rechten?.AanvragenBeoordelen || rechten?.FullAccess || rechten?.Administrator || isNGW ? (
            <Suspense fallback={<div className="p-6">Laden...</div>}>
              <Layout><AanvragenBeoordelen /></Layout>
            </Suspense>
          ) : <Navigate to="/" />
        }
      />

      <Route
        path="/adminbeheer"
        element={
          rechten?.Administrator ? (
            <Suspense fallback={<div className="p-6">Laden...</div>}>
              <Layout><AdminBeheer /></Layout>
            </Suspense>
          ) : <Navigate to="/" />
        }
      />
<Route
        path="/compliance"
        element={
          rechten?.Administrator ? (
            <Suspense fallback={<div className="p-6">Laden...</div>}>
              <Layout><Compliance /></Layout>
            </Suspense>
          ) : <Navigate to="/" />
        }
      />

      <Route
        path="/agendatoegang"
        element={
          rechten?.AgendaToegangBeheer || rechten?.FullAccess || rechten?.Administrator ? (
            <Suspense fallback={<div className="p-6">Laden...</div>}>
              <Layout><AgendaToegang/></Layout>
            </Suspense>
          ) : <Navigate to="/" />
        }
      />

      <Route
        path="/mailboxtoegang"
        element={
          rechten?.MailboxToegangBeheer || rechten?.FullAccess || rechten?.Administrator ? (
            <Suspense fallback={<div className="p-6">Laden...</div>}>
              <Layout><MailboxToegang/></Layout>
            </Suspense>
          ) : <Navigate to="/" />
        }
      />
      <Route
  path="/klant-onboarding"
  element={
    rechten?.Administrator ? (
      <Suspense fallback={<div className="p-6">Laden...</div>}>
        <Layout><KlantOnboarding /></Layout>
      </Suspense>
    ) : <Navigate to="/" />
  }
/>

      <Route
  path="/mfa-reset"
  element={
    rechten?.MfaReset || rechten?.FullAccess || rechten?.Administrator ? (
      <Suspense fallback={<div className="p-6">Laden...</div>}>
        <Layout><MfaReset /></Layout>
      </Suspense>
    ) : <Navigate to="/" />
  }
/>

      <Route path="/mijnaanvragen" element={<Layout><MijnAanvragen /></Layout>} />
    </Routes>
  );
}
